<template>
  <div>
    <page-title pageName="货品管理"/>
    <div class='comm-container' v-if='tabList.length > 0'>
      <div class='goods-tab'>
        <el-tabs
          v-model="activeName"
          type="card"
          @tab-click="handleClick">
          <el-tab-pane
            v-for='item in tabList'
            :key='item.id'
            :label="item.typeName"
            :name="item.id"/>
        </el-tabs>
      </div>
      <div class='good-select-box'>
        <el-row class='plr15 select-row select-row-one'>
          <el-col :span='12'>货品筛选</el-col>
          <el-col :span='12'  class='text-right primary-color'><span @click='isOpenBtn' class='pointer'>收起</span> </el-col>
        </el-row>
        <div class='plr15 select-row' v-show='isOpen'>
          <span>颜色(支持多选)：</span>
          <span v-bind:class="[{isSelect:item.isSelect},'good-selectwidth']"  @click='chooseSelect(item,"selectColor")' v-for='item in selectColor' :key='item.id'>{{item.name}}</span>
        </div>
        <div class='plr15 select-row' v-show='isOpen'>
          <span>净度：</span>
          <span v-bind:class="[{isSelect:item.isSelect},'good-selectwidth']" @click='chooseSelect(item,"selectNetWeight")' v-for='item in selectNetWeight' :key='item.id'>{{item.name}}</span>
        </div>
        <div class='plr15 select-row' v-show='isOpen'>
          <span>荧光(支持多选)：</span>
          <span v-bind:class="[{isSelect:item.isSelect},'good-selectwidth']" @click='chooseSelect(item,"selectGoodsFluorescence")' v-for='item in selectGoodsFluorescence' :key='item.id'>{{item.name}}</span>
        </div>
        <div class='plr15 select-row' v-show='isOpen'>
          <span>规格(直径)：</span>
          <span v-bind:class="[{isSelect:item.isSelect},'good-selectwidth']" @click='chooseSelect(item,"selectDiameter")' v-for='item in selectDiameter' :key='item.id'>{{item.name}}</span>
          <el-input
          v-model='minSpecifications'
          placeholder='0'
          class='comm-search-con'
          size='small'/>
          -
          <el-input
          v-model='maxSpecifications'
          placeholder='0'
          class='comm-search-con'
          size='small'/>
        </div>
        <div class='plr15 select-row' v-show='isOpen'>
          <span>切工(支持多选)：</span>
          <span v-bind:class="[{isSelect:item.isSelect},'good-selectwidth']" @click='chooseSelect(item,"selectCut")' v-for='item in selectCut' :key='item.id'>{{item.name}}</span>
        </div>
        <div class='plr15 select-row' v-show='isOpen'>
          <span>形状：</span>
          <span v-bind:class="[{isSelect:item.isSelect},'good-selectwidth']" @click='chooseSelect(item,"selectShape")' v-for='item in selectShape' :key='item.id'>{{item.name}}</span>
        </div>
        <div class='plr15 select-row' v-show='isOpen'>
          <span>重量：</span>
          <span v-bind:class="[{isSelect:item.isSelect},'good-selectwidth']" @click='chooseSelect(item,"selectWeight")' v-for='item in selectWeight' :key='item.id'>{{item.name === '0.8' ? item.name+'↑'  : item.name}}</span>
          <el-input
          v-model='minWeight'
            placeholder='0'
          class='comm-search-con'
          size='small'/>
          -
          <el-input
          v-model='maxWeight'
          placeholder='0'
          class='comm-search-con'
          size='small'/>
        </div>
        <div class='plr15 select-row' v-show='isOpen'>
          <span>证书：</span>
          <span v-bind:class="[{isSelect:item.isSelect},'good-selectwidth']" @click='chooseSelect(item,"selectCertificate")' v-for='item in selectCertificate' :key='item.id'>{{item.name}}</span>
        </div>
        <el-row class='plr15  select-row'>
          <el-col :span='12'>
            <el-input
              v-model='searchValue'
              placeholder='请输入证书号'
              class='comm-search-con'
              size='small'/>
            <span class='ml20'>价格：</span>
            <el-input
            v-model='minValue'
              placeholder='9999999999'
            class='comm-search-con'
            size='small'/>
            -
            <el-input
            v-model='maxValue'
            placeholder='9999999999'
            class='comm-search-con'
            size='small'/>
          </el-col>
          <el-col :span='12' class='text-right'>
            <el-button
              size='small'
              type="primary"
              class='ml10' @click='selectBtn'>查询</el-button>
            <el-button
              size='small' @click='resetBtn'>重置</el-button>
            <el-button
              size='small'
              type='success'
              @click='importBtn(2)'
              >导入图片</el-button>
          </el-col>
        </el-row>
      </div>
      <div class='comm-page-container mt20'>
        <el-row class='pd10'>
          <el-col
            :span='24'
            class='text-right'>
            <el-button
              @click='exportBtn'
              size='small'
              plain>导出</el-button>
            <el-button
              size='small'
              @click='importBtn(1)'
              v-if='activeName !== "-1"'
              plain>导入</el-button>
            <el-button
              size='small'
              v-if='activeName !== "-1"'
              type="primary" @click='addGoods'>添加</el-button>
          </el-col>
        </el-row>
        <el-table
          class='goods-table'
          ref="multipleTable"
          :data="tableData"
           @sort-change='sortChange'
          border
          @selection-change="handleSelectionChange">
          <el-table-column
            align='center'
            type="selection"
            width="45"/>
          <el-table-column
            label="证书"
            align='center'
            sortable='custom'
            width='120px'
            prop='goodsCertificate'
            >
            <template slot-scope="scope">
              <i v-if='scope.row.goodsCertificateUrl' class='primary-color  goods-img-zs pointer'>
                {{ scope.row.goodsCertificate }}
                 <el-image 
                  src="https://www.xhxh1993.com/img/logo.42afd089.png"
                  :preview-src-list="scope.row.scopesrcList1">
                </el-image>
              </i>
              <i v-else >{{ scope.row.goodsCertificate }}</i>
            </template>
          </el-table-column>
          <el-table-column
            prop='hdimgUrl'
            align='center'
            label="HD图片">
            <template slot-scope="scope">
              <i v-if='scope.row.hdimgUrl' class='iconfont goods-img-suolue iconpic primary-color pointer'>
                <el-image 
                  src="https://www.xhxh1993.com/img/logo.42afd089.png"
                  :preview-src-list="scope.row.scopesrcList">
                </el-image>
              </i>
              <i v-else class='iconfont iconpic'></i>
            </template>
          </el-table-column>
          <el-table-column
            sortable
            width='120px'
            align='center'
            prop='goodsCertificateNum'
            label="证书号"/>
          <el-table-column
            sortable='custom'
            align='center'
            prop='goodsShape'
            label="形状"/>
          <el-table-column
            sortable
            align='center'
            prop='goodsNum'
            label="数量">
            <template slot-scope="scope">
              <div>
                {{!scope.row.goodsNum ? '/' : scope.row.goodsNum}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            sortable='custom'
            align='center'
            prop='goodsWeight'
            label="重量">
            <template slot-scope="scope">
              <div>
                {{scope.row.goodsWeight ? toDecimal2(scope.row.goodsWeight,3) : '/'}}
                <!-- {{scope.row.goodsWeight}} -->
              </div>
            </template>
          </el-table-column>
          <el-table-column
            sortable
            width='50px'
            align='center'
            prop='pricingMethod'
            label="计价方式">
            <template slot-scope="scope">
              <div>
                {{scope.row.pricingMethod === '请选择' || !scope.row.pricingMethod ? '/' : scope.row.pricingMethod}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            sortable='custom'
            align='center'
            prop='goodsColour'
            label="颜色">
            <template slot-scope="scope">
              <div>
                {{scope.row.goodsColour === '请选择' || !scope.row.goodsColour ? '/' : scope.row.goodsColour}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            sortable='custom'
            align='center'
            prop='goodsCleanliness'
            label="净度">
            <template slot-scope="scope">
              <div>
                {{scope.row.goodsCleanliness === '请选择' || !scope.row.goodsCleanliness ? '/' : scope.row.goodsCleanliness}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            sortable='custom'
            align='center'
            prop='goodsCutwork'
            label="切工">
            <template slot-scope="scope">
              <div>
                {{scope.row.goodsCutwork === '请选择' || !scope.row.goodsCutwork ? '/' : scope.row.goodsCutwork}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            sortable='custom'
            align='center'
            prop='goodsSpecifications'
            label="规格">
            <template slot-scope="scope">
              <div>
                {{!scope.row.goodsSpecifications ? '/' : toDecimal2(scope.row.goodsSpecifications,2)}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            sortable
            align='center'
            prop='goodsSymmetric'
            label="对称">
            <template slot-scope="scope">
              <div>
                {{scope.row.goodsSymmetric === '请选择' || !scope.row.goodsSymmetric ? '/' : scope.row.goodsSymmetric}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            sortable
            align='center'
            prop='goodsPolishing'
            label="抛光">
            <template slot-scope="scope">
              <div>
                {{scope.row.goodsPolishing === '请选择' || !scope.row.goodsPolishing ? '/' : scope.row.goodsPolishing}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            sortable='custom'
            align='center'
            prop='goodsFluorescence'
            label="荧光">
            <template slot-scope="scope">
              <div>
                {{scope.row.goodsFluorescence === '请选择' || !scope.row.goodsFluorescence ? '/' : scope.row.goodsFluorescence}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            sortable='custom'
            align='center'
            width='120px'
            prop='goodsPrice'
            label="价格">
            <template slot-scope="scope">
              <div>
                {{!scope.row.goodsPrice ? '/' : scope.row.goodsPrice}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            sortable
            align='center'
            prop='isUppershelf'
            label="上架">
            <template slot-scope="scope">
              <div>
                <el-switch
                 size='mini'
                  :value="scope.row.isUppershelf===1" 
                  @input="inputIsOut($event,scope.row)"
                  active-color="#409EFF"
                  inactive-color="#ff4949">
                </el-switch>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            align='center'
            sortable
            prop='goodsTone'
            label="色调">
            <template slot-scope="scope">
              <div>
                {{scope.row.goodsTone === '请选择' || !scope.row.goodsTone ? '/' : scope.row.goodsTone}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            width='200px'
            align='center'
            label="操作">
            <template slot-scope="scope">
              <div>
                <el-button size='mini' plain type="primary" @click='editBtn(scope.row)'>编辑</el-button>
                <el-button size='mini' plain type="danger" @click='delBtn(scope.row)'>删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-row class='mt10 pd10'>
          <el-col :span='12'>
            <el-button
              size='small'
              type="primary" @click='batchBtn(1)'>批量上架</el-button>
            <el-button
              size='small'
              type="primary" @click='batchBtn(2)'>批量下架</el-button>
            <el-button
              size='small'
              type="danger" @click='batchBtn(3)'>批量删除</el-button>
          </el-col>
          <el-col :span='12' class='text-right'>
            <el-pagination
              :current-page="currentPage"
              :page-sizes="pageSizes"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"/>
          </el-col>
        </el-row>
      </div>

      <div class='show-image' v-if='showImageDialog' @click='handleCloseImage' >
        <i class='el-icon-close' @click='handleCloseImage'></i>
        <div class='img'>
          <img :src="currImageUrl" @click.stop alt="">
        </div>
      </div>
    </div>
    <div class='comm-container' v-else>
      <div class='no-type-list'>请添加分类</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Goods',
  data () {
    return {
      sortArr:['','goodsCertificate','','goodsShape','','goodsWeight','','goodsColour','','goodsCleanliness','','goodsCutwork','','goodsSpecifications','','goodsFluorescence','','goodsPrice',''],
      sortType:0,
      baseUrl: this.$api.baseUrl,
      showImageDialog:false,
      activeName:null,
      pageSizes: [20, 50, 60, 100],
      maxValue:'',
      minValue:'',
      pageSize: 20,
      currentPage:1,
      total: 0,
      tabList: [],
      searchValue: '',
      selectColor:[
        {id:-1,name:'全部',isSelect:1},
        {id:1,name:'D-E',isSelect:0},
        {id:2,name:'F-G',isSelect:0},
        {id:3,name:'H',isSelect:0},
        {id:4,name:'I-J',isSelect:0},
        {id:5,name:'J-K',isSelect:0},
        {id:6,name:'K-L',isSelect:0},
        {id:7,name:'L-M',isSelect:0},
        {id:8,name:'M-N',isSelect:0},
        {id:9,name:'<N',isSelect:0},
      ],
      selectNetWeight:[
        {id:-1,name:'全部',isSelect:1},
        {id:1,name:'VVS-VS',isSelect:0},
        {id:2,name:'SI1-SI2',isSelect:0},
        {id:3,name:'SI2以下',isSelect:0},
      ],
      selectGoodsFluorescence:[
        {id:-1,name:'全部',isSelect:1},
        {id:1,name:'N',isSelect:0},
        {id:2,name:'F',isSelect:0},
        {id:3,name:'M',isSelect:0},
        {id:4,name:'S',isSelect:0},
      ],
      selectDiameter:[
        {id:-1,name:'全部',isSelect:1},
        {id:1,name:'6.2以上',isSelect:0},
        {id:2,name:'6.0-6.19',isSelect:0},
        {id:3,name:'5.8-5.99',isSelect:0},
        {id:4,name:'5.8以下',isSelect:0}
      ],
      selectCut:[
        {id:-1,name:'全部',isSelect:1},
        {id:1,name:'EX',isSelect:0},
        {id:2,name:'VG',isSelect:0},
        {id:3,name:'G',isSelect:0},
        {id:4,name:'F',isSelect:0},
        {id:5,name:'P',isSelect:0},
      ],
      selectShape:[
        {id:-1,name:'全部',isSelect:1},
        {id:1,name:'梨形',isSelect:0},
        {id:2,name:'祖母',isSelect:0},
        {id:3,name:'公主方',isSelect:0},
        {id:4,name:'三角形',isSelect:0},
        {id:5,name:'椭圆形',isSelect:0},
        {id:6,name:'垫形',isSelect:0},
        {id:7,name:'马眼',isSelect:0},
        {id:8,name:'爱心形',isSelect:0},
        {id:9,name:'六角形',isSelect:0},
        {id:10,name:'其他',isSelect:0}
      ],
      selectWeight:[
        {id:-1,name:'全部',isSelect:1},
        {id:1,name:'0.3',isSelect:0},
        {id:2,name:'0.4',isSelect:0},
        {id:3,name:'0.5',isSelect:0},
        {id:4,name:'0.6',isSelect:0},
        {id:5,name:'0.7',isSelect:0},
        {id:6,name:'0.8',isSelect:0},
      ],
      selectCertificate:[
        {id:-1,name:'全部',isSelect:1},
        {id:1,name:'NGTC',isSelect:0},
        {id:2,name:'GIA',isSelect:0},
        {id:3,name:'TS',isSelect:0},
        {id:4,name:'广东省检',isSelect:0},
        {id:5,name:'散货',isSelect:0},
        {id:6,name:'其他证书',isSelect:0}
      ],
      selectColorId:[],
      selectNetWeightId:null,
      selectDiameterId:null,
      minSpecifications:0,
      maxSpecifications:'',
      minWeight:0,
      maxWeight:'',
      selectCutId:[],
      selectShapeId:null,
      selectWeightId:null,
      selectCertificateId:null,
      selectGoodsFluorescenceId:[],
      isOpen:1,
      tableData: [],
      multipleSelection: [],
      currTab:null,
      currImageUrl:null,
      currHost:window.location.host
    }
  },
  watch:{
    selectDiameterId(newVal){
      let v = newVal ? newVal : -1
      this.handleDiameterValue(v)
    },
    selectWeightId(newVal){
      let v = newVal ? newVal : -1
      this.handleWeightValue(newVal)
    },
    // minWeight(newVal){
    //   if(!newVal && newVal !== 0){
    //     this.handleWeightValue(this.selectWeightId)
    //   }
    // },
    // maxWeight(newVal){
    //   if(!newVal && newVal !== 0){
    //     this.handleWeightValue(this.selectWeightId)
    //   }
    // },
    // minSpecifications(newVal){
    //   if(!newVal && newVal !== 0){
    //     this.handleDiameterValue(this.selectDiameterId)
    //   }
    // },
    // maxSpecifications(newVal){
    //   if(!newVal && newVal !== 0){
    //     this.handleDiameterValue(this.selectDiameterId)
    //   }
    // },
  },
  mounted(){
    let obj = JSON.parse(localStorage.getItem('operHistory'))
    if(obj){
      this.activeName = obj.activeName
      this.pageSize = obj.pageSize
      this.currentPage = obj.currentPage
    }
    this.getTabData()
  },
  methods: {
    handleDiameterValue(newVal){
      switch(newVal){
        case -1:
          this.minSpecifications = 0
          this.maxSpecifications = ''
          break;
        case 1:
          this.minSpecifications = 6.2
          this.maxSpecifications = ''
          break;
        case 2:
          this.minSpecifications = 6.0
          this.maxSpecifications = 6.19
          break;
        case 3:
          this.minSpecifications = 5.8
          this.maxSpecifications = 5.99
          break;
        case 4:
          this.minSpecifications = 0
          this.maxSpecifications = 5.79
          break;
      }
    },
    handleWeightValue(newVal){
      switch(newVal){
        case -1:
          this.minWeight = 0
          this.maxWeight = ''
          break;
        case 6:
          this.minWeight = 0.8
          this.maxWeight = ''
          break;
        default:
          let i = newVal === 1 ? 0 : '0.'+(newVal+2)
          let a = '0.'+(newVal+2)+'99'
          this.minWeight = parseFloat(i)
          this.maxWeight = parseFloat(a)
      }
    },
    toDecimal2(x,num) {
      var f = parseFloat(x);
      if (isNaN(f)) {
        return false;
      }
      var f = Math.round(x*1000)/1000;
      var s = f.toString();
      var rs = s.indexOf('.');
      if (rs < 0) {
        rs = s.length;
        s += '.';
      }
      while (s.length <= rs + num) {
        s += '0';
      }
      return s;
    },
    isOpenBtn(){
      this.isOpen = this.isOpen === 1 ? 0 : 1
    },
    chooseSelect(list,name){
      if(name === 'selectCut' || name === 'selectGoodsFluorescence' || name === "selectColor"){
        let index = this[name+'Id'].indexOf(list.id)
        if(index < 0){
          if(list.id === -1){
            this[name+'Id'] = []
            this[name].forEach(item => {
              item.isSelect = item.id === -1 ? 1 : 0
            })
          }else{
            this[name+'Id'].push(list.id)
            if(this[name+'Id'].indexOf(-1) >= 0){
              this[name+'Id'].splice(this[name+'Id'].indexOf(-1),1)
            }
            this[name].forEach(item => {
              if(item.id === list.id){
                item.isSelect = 1
              }
              if(item.id === -1){
                item.isSelect = 0
              }
            })
          }
        }else{
          this[name+'Id'].splice(index,1)
          this[name].forEach(item => {
            if(item.id === list.id){
              item.isSelect = 0
            }
          })
        }
        return
      }
      this[name+'Id'] = list.id
      this[name].forEach(item => {
        if(list.id === item.id){
          item.isSelect = 1
        }else{
          item.isSelect = 0
        }
      })
    },
    getTabData(){
      this.$ajax({
        method:'post',
        url:'goodsType/selectGoodsTypes',
        data:{typeName:null}
      }).then(res => {
        if(res.data.code > 0){
          if(res.data.list && res.data.list.length > 0){
            res.data.list.forEach(item => {
              item.id = item.id.toString()
            })
          }
          this.tabList =res.data.list || []
          if(this.tabList.length > 0){
            let obj = {id:'-1',typeName:'全部'}
            this.tabList.unshift(obj)
          }
          this.activeName = this.activeName ? this.activeName : (this.tabList.length > 0 ?  this.tabList[0].id.toString() : null)
          this.currTab = this.tabList.length > 0 ?  this.tabList[0] : null
          this.getData(this.activeName)
        }else{
          this.$message.warning(res.data.desc)
        }
      })
    },
    getData(tabId){
      let params = {
        pageSize:this.pageSize,
        pageNum:this.currentPage,
        goodsTypeId:this.activeName !== '-1' ? parseInt(this.activeName) : null,
        goodsCertificate:this.selectCertificateId === -1 ? null : this.selectCertificateId,
        goodsCertificateNum:this.searchValue || null, //证书号
        goodsColour:!this.selectColorId.length ? null : this.selectColorId, //yanse
        goodsCleanliness:this.selectNetWeightId === -1 ? null : this.selectNetWeightId, //jingzhong
        goodsFluorescence:!this.selectGoodsFluorescenceId.length ? null : this.selectGoodsFluorescenceId, //yingguang
        goodsShape:null,
        goodsCutwork:null,
        minGoodsPrice:this.minValue || null,
        maxGoodsPrice:this.maxValue || null,
        minWeight:this.minWeight || null,
        maxWeight:this.maxWeight || null,
        minSpecifications:this.minSpecifications || null,
        maxSpecifications:this.maxSpecifications || null
      }
      this.selectShape.forEach(item => {
        if(item.id === this.selectShapeId){
          params.goodsShape = item.name === '全部' ? null : item.name
        }
      })
      let cutArr = []
      this.selectCut.forEach(item => {
        if(this.selectCutId.indexOf(item.id) >= 0){
          cutArr.push(item.name)
        }
      })
      params.goodsCutwork = cutArr.length > 0 ? cutArr : null
      if(this.sortType > 0){
        params.sortType = this.sortType
      }
      this.$ajax({
        method:'post',
        url:'goods/selectGoodsByPage',
        data:params
      }).then(res => {
        if(res.data.code > 0){
          if(res.data.data.list && res.data.data.list.length > 0){
            res.data.data.list.forEach(item => {
              if(item.hdimgUrl){
                item.scopesrcList = ['//'+this.currHost+'/img/'+item.hdimgUrl]
              }
              if(item.goodsCertificateUrl){
                item.scopesrcList1 = ['//'+this.currHost+'/img/'+item.goodsCertificateUrl]
              }
            })
          }
          this.tableData = res.data.data.list
          this.total = res.data.data.total
        }else{
          this.$message.warning(res.data.desc)
        }
      })
    },
    exportBtn(){
      let params = {
        goodsTypeId:this.activeName !== '-1' ? parseInt(this.activeName) : null,
        goodsCertificate:this.selectCertificateId === -1 ? null : this.selectCertificateId,
        goodsCertificateNum:this.searchValue || null, //证书号
        goodsColour:!this.selectColorId.length ? null : this.selectColorId, //yanse
        goodsCleanliness:this.selectNetWeightId === -1 ? null : this.selectNetWeightId, //jingzhong
        goodsFluorescence:!this.selectGoodsFluorescenceId.length ? null : this.selectGoodsFluorescenceId, //yingguang
        goodsShape:null,
        goodsCutwork:null,
        minGoodsPrice:this.minValue || null,
        maxGoodsPrice:this.maxValue || null,
        minWeight:this.minWeight || null,
        maxWeight:this.maxWeight || null,
        minSpecifications:this.minSpecifications || null,
        maxSpecifications:this.maxSpecifications || null
      }
      this.selectShape.forEach(item => {
        if(item.id === this.selectShapeId){
          params.goodsShape = item.name
        }
      })
      let cutArr = []
      this.selectCut.forEach(item => {
        if(this.selectCutId.indexOf(item.id) >= 0){
          cutArr.push(item.name)
        }
      })
      params.goodsCutwork = cutArr.length > 0 ? cutArr : null
      if(this.sortType > 0){
        params.sortType = this.sortType
      }
      this.$ajax({
        method:'post',
        url:'goods/export',
        responseType: 'blob',
        data:params
      }).then(res => {
        let a = document.createElement('a')
        
        a.style.display = 'none'
        a.href = URL.createObjectURL(res.data)
        a.download = this.currTab.typeName+'.xls' // 指定的文件名
        document.body.appendChild(a)
        a.click()
        
      })
    },
    batchBtn(type){
      let url = '',txt='',successTxt = ''
      let params = {}
      if(type === 1){
        url='goods/updateGoodsUppershelf'
        txt='确认上架？'
        successTxt='上架成功'
        params.isUppershelf = 1
      }else if(type === 2){
        url='goods/updateGoodsUppershelf'
        txt='确认下架？'
        successTxt='下架成功'
        params.isUppershelf = 0
      }else{
        url='goods/deleteGoods'
        txt='确认删除？'
        successTxt='删除成功'
      }
      params.ids = this.multipleSelection.map(item => {return item.goodsId})
      this.$confirm(txt, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          method:'post',
          url:url,
          data:type === 3 ? params.ids : params,
        }).then(res => {
          if(res.data.code > 0){
            this.$message.success(successTxt)
            this.getData(this.activeName)
          }else{
            this.$messgae.warning(res.data.desc)
          }
        })
      })
    },
    inputIsOut (e, row) {
      row.isUppershelf = e ? 1 : 0
      this.$confirm('确认修改当前状态', '修改确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        let params = {
          ids:[row.goodsId],
          isUppershelf:row.isUppershelf
        }
        this.$ajax({
          method:'post',
          url:'goods/updateGoodsUppershelf',
          data:params,
        }).then(res => {
          if(res.data.code > 0){
            this.$message.success(successTxt)
            this.getData(this.activeName)
          }else{
            this.$messgae.warning(res.data.desc)
          }
        })
      })
    },
    editBtn(item){
      // item.hdimgUrl =item.hdimgUrl ?  'http://47.115.36.20:8080/img/'+item.hdimgUrl : null
      // item.goodsCertificateUrl =item.goodsCertificateUrl ?  'http://47.115.36.20:8080/img/'+item.goodsCertificateUrl : null
      
      let obj = {
        activeName:this.activeName,
        pageSize:this.pageSize,
        currentPage:this.currentPage
      }
      localStorage.setItem('operHistory',JSON.stringify(obj))
      localStorage.setItem('goodsDetail',JSON.stringify(item))
      this.$router.push({
        path:'/addGoods',
        query:{
          tabId:item.goodsTypeId,
          isEdit:1
        }
      })
    },
    delBtn(item){
      this.$confirm('确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          method:'post',
          url:'goods/deleteGoods',
          data:[item.goodsId],
        }).then(res => {
          if(res.data.code > 0){
            this.$message.success('删除成功')
            this.getData(this.activeName)
          }else{
            this.$messgae.warning(res.data.desc)
          }
        })
      })
    },
    selectBtn(){
      let reg = /^[0-9]+.?[0-9]*$/
      if(this.maxSpecifications && !reg.test(this.maxSpecifications)){
        this.$message.error('最高规格须为大于0的数字')
        return
      }
      if(this.minSpecifications && !reg.test(this.minSpecifications)){
        this.$message.error('最低规格须为大于等于0的数字')
        return
      }
      if(this.maxSpecifications && this.minSpecifications && this.maxSpecifications < this.minSpecifications){
        this.$message.error('最高规格不能低于最低规格')
        return
      }
      if(this.maxWeight && !reg.test(this.maxWeight)){
        this.$message.error('最高重量须为大于0的数字')
        return
      }
      if(this.minWeight && !reg.test(this.minWeight)){
        this.$message.error('最低重量须为大于等于0的数字')
        return
      }
      if(this.maxWeight && this.minWeight && this.maxWeight < this.minWeight){
        this.$message.error('最高重量不能低于最低重量')
        return
      }
      if(this.maxValue < this.minValue){
        this.$message.error('高价不能低于低价！')
        return
      }
      this.currentPage = 1
      this.getData(this.activeName)
    },
    handleClick(){
      this.tabList.forEach(item => {
        if(item.id === this.activeName){
          this.currTab = item
        }
      })
      this.currentPage = 1
      this.getData(this.activeName)
    },
    resetBtn(){
      this.searchValue = null
      this.maxValue = null
      this.minValue = null
      let arr = ['selectColor','selectNetWeight','selectGoodsFluorescence','selectDiameter','selectCut','selectShape','selectWeight','selectCertificate']
      for(let i = 0;i<arr.length;i++){
        this[arr[i]].forEach(item => {
          if(item.id === -1){
            item.isSelect = 1
          }else{
            item.isSelect = 0
          }
        })
      }
      this.sortType = 0
      this.selectColorId = []
      this.selectNetWeightId = null
      this.selectGoodsFluorescenceId = []
      this.selectDiameterId = null
      this.selectCutId = []
      this.selectShapeId = null
      this.selectWeightId = null
      this.selectCertificateId =null
      this.getData(this.activeName)
    },
    addGoods(){
      let obj = {
        activeName:this.activeName,
        pageSize:this.pageSize,
        currentPage:this.currentPage
      }
      localStorage.setItem('operHistory',JSON.stringify(obj))
      this.$router.push({
        path:'/addGoods',
        query:{
          tabId:this.activeName
        }
      })
    },
    handleSelectionChange (val) {
      this.multipleSelection = []
      this.multipleSelection = val
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.multipleSelection = []
      this.getData(this.activeName)
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getData(this.activeName)
    },
    importBtn(type){
      let obj = {
        activeName:this.activeName,
        pageSize:this.pageSize,
        currentPage:this.currentPage
      }
      let url =''
      if(type === 1){
        url ='/import'
      }else{
        url ='/ImportImages'
      }
      localStorage.setItem('operHistory',JSON.stringify(obj))
      this.$router.push({
        path:url,
        query:{
          tabId:this.activeName
        }
      })
    },
    showImage(item,name){
      this.showImageDialog = true
      // this.currImageUrl = '//'+this.currHost+'/img/'+item[name]
      // this.currImageUrl = 'http://47.115.36.20:8080/img/'+item[name]
      console.log(this.currImageUrl)
    },
    handleCloseImage(){
      this.showImageDialog = false
      this.currImageUrl = null
    },
    getSortDetail(name,order){

    },
    sortChange (column, prop, order) {
      let index = this.sortArr.indexOf(column.prop)
      if(index >= 0){
        if(column.order === 'ascending'){
          this.sortType = index
        }else if(column.order === 'descending'){
          this.sortType = index+1
        }else{
          this.sortType = 0
        }
        
        this.currentPage = 1
        this.getData(this.activeName)
      }else{
          this.sortType = 0
      }
    }
  }
}
</script>
<style scoped>
.goods-tab{
    background: #fff;
    margin-bottom:20px;
}
.goods-tab >>> .el-tabs--card>.el-tabs__header{
    border-bottom:none;
}
.goods-tab >>> .el-tabs__header{
    margin:0;
}
.goods-tab >>> .el-tabs__item{
    height:auto;
    padding:16px 20px;
    line-height: unset;
}
.goods-tab >>> .el-tabs--card>.el-tabs__header .el-tabs__item{
    border-bottom: 1px solid #E4E7ED;
}
.goods-tab >>> .el-tabs__item.is-active{
    color:#475eff;
}
.goods-tab >>> .el-tabs--card>.el-tabs__header .el-tabs__item.is-active{
    border-bottom-color: #475eff;
    border-bottom-width: 2px;
}
.good-select-box{
  background: #fff;;
}
.good-selectwidth{
  display: inline-block;
  width:82px;
  padding:10px 0;
  margin-right:5px;
  border-radius: 24px;
  text-align: center;
  cursor: pointer;
}
.select-row{
  border-bottom:1px solid #ededed;
  padding: 10px 15px;
  font-size:14px;
}
.select-row-one{
  padding:20px 15px;
}

.good-selectwidth.isSelect{
  background: #0079fe;
  color:#fff;
}
.no-type-list{
  text-align: center;
  color:#111;
  font-size:16px;
  /* font-weight:bold; */
  background:#fff;
  height:500px;
  line-height:500px;
}
.goods-table{
  font-size:12px;
}
.goods-img-suolue{
  position: relative;
  width:16px;
  height:16px;
  display: inline-block;
}
.goods-img-suolue >>> .el-image{
  position: absolute;
  width: 17px;
  height: 17px;
  top:0;
  left:0;
}
.goods-img-suolue >>> .el-icon-circle-close,
.goods-img-zs >>> .el-icon-circle-close{
  color:#fff;
}
.goods-img-suolue >>> .el-image__preview{
  width: 17px;
  height: 17px;
  opacity: 0;
  z-index: 11;
}
.goods-img-zs{
  position: relative;
}
.goods-img-zs >>> .el-image,
.goods-img-zs >>> .el-image__inner{
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.goods-img-zs >>> .el-image{
  overflow: hidden;
}
.goods-img-zs >>> .el-image__inner{
  opacity: 0;
}
</style>
